import { render, staticRenderFns } from "./Penalties.vue?vue&type=template&id=72e01c86&scoped=true&"
import script from "./Penalties.vue?vue&type=script&lang=js&"
export * from "./Penalties.vue?vue&type=script&lang=js&"
import style0 from "./Penalties.vue?vue&type=style&index=0&id=72e01c86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e01c86",
  null
  
)

export default component.exports